import axios from '@/utils/axios';

export const uploadImage = async (formData: FormData) =>
  axios.post('/upload/public', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
